export const isSelectedSegment = (view, segment, mode) => view.get(segment).selected === mode;
